import React from "react";
import { Link } from "react-router-dom";
import { useCookieCtx } from "@/components/CookieBanner";

export default function Footer() {
  const cookieCtx = useCookieCtx();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#06080F] text-slate-300 py-16 border-t border-amber-300/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-10 items-start">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3">
              <span
                className="block h-12 w-12 rounded-xl bg-[#0A0D17] ring-1 ring-amber-300/20"
                style={{
                  backgroundImage: "url(/brand/logo.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "150% auto",
                  backgroundPosition: "50% 18%",
                }}
              />
              <div>
                <div className="font-heading text-lg font-bold text-white">STK Komfort</div>
                <div className="text-[11px] uppercase tracking-[0.18em] text-amber-300/80">Znojmo</div>
              </div>
            </div>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed">
              STK Komfort™ — STK, emise, evidenční kontroly, přepisy vozidel, převozní značky,
              pojištění, autoservis, DPF, odtah a další auto služby pro Znojmo a okolí.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-amber-300/80">Rychlé odkazy</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="/#sluzby" className="hover:text-amber-300 transition-colors">Služby</a></li>
              <li><a href="/#cenik" className="hover:text-amber-300 transition-colors">Ceník</a></li>
              <li><a href="/objednavka" className="hover:text-amber-300 transition-colors font-semibold">Objednat službu</a></li>
              <li><a href="/#pro-firmy" className="hover:text-amber-300 transition-colors">Pro firmy</a></li>
              <li><a href="/#pro-seniory" className="hover:text-amber-300 transition-colors">Pro seniory</a></li>
              <li><a href="/#o-nas" className="hover:text-amber-300 transition-colors">O nás</a></li>
              <li><a href="/#kontakt" className="hover:text-amber-300 transition-colors">Kontakt</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-amber-300/80">Kontakt</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li className="text-white font-semibold">Lenka Garguláková</li>
              <li><a href="tel:+420775659129" className="text-amber-300 hover:text-amber-200">+420 775 659 129</a></li>
              <li><a href="mailto:info.stkkomfort@gmail.com" className="text-amber-300 hover:text-amber-200 break-all">info.stkkomfort@gmail.com</a></li>
              <li className="text-slate-400">Sedlešovice 34</li>
              <li className="text-slate-400">Nový Šaldorf — autoopravna</li>
              <li className="text-slate-500 text-xs mt-2">Návštěvy pouze po telefonické domluvě</li>
              <li className="mt-4 flex flex-wrap gap-2">
                <a
                  href="https://www.facebook.com/stkkomfortznojmo"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-facebook-link"
                  className="inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold text-white hover:opacity-90 transition-opacity shadow-[0_6px_16px_-6px_rgba(24,119,242,0.5)]"
                  style={{ backgroundColor: "#1877F2" }}
                >
                  <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06C2 17.08 5.66 21.24 10.44 22v-7.03H7.9v-2.9h2.54V9.85c0-2.51 1.49-3.9 3.77-3.9 1.1 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.77-1.63 1.57v1.88h2.78l-.44 2.9h-2.34V22C18.34 21.24 22 17.08 22 12.06z"/>
                  </svg>
                  Facebook
                </a>
                <a
                  href="https://wa.me/420775659129"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  aria-label="Napsat na WhatsApp STK Komfort Znojmo"
                  className="inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold text-white hover:opacity-90 transition-opacity shadow-[0_6px_16px_-6px_rgba(37,211,102,0.5)]"
                  style={{ backgroundColor: "#25D366" }}
                >
                  <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 2.1.55 4.15 1.6 5.97L2 22l4.25-1.11c1.75.96 3.73 1.47 5.79 1.47h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.83 9.83 0 0 0 12.04 2zm4.49 11.94c-.25-.12-1.46-.72-1.69-.8-.23-.08-.39-.12-.56.12-.16.25-.64.8-.78.96-.14.16-.29.18-.54.06-.25-.12-1.04-.38-1.98-1.22-.73-.65-1.22-1.46-1.37-1.71-.14-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.13-.15.16-.25.25-.41.08-.16.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.49-.4-.42-.55-.43-.14-.01-.31-.01-.47-.01a.9.9 0 0 0-.65.31c-.22.25-.86.84-.86 2.05 0 1.21.88 2.38 1 2.55.12.16 1.74 2.66 4.22 3.73.59.25 1.05.41 1.41.52.59.19 1.13.16 1.55.1.47-.07 1.46-.6 1.66-1.18.21-.58.21-1.07.14-1.18-.06-.12-.22-.18-.47-.31z"/>
                  </svg>
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-amber-300/80">Právní informace</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/ochrana-osobnich-udaju" className="hover:text-amber-300" data-testid="footer-link-privacy">Ochrana osobních údajů</Link></li>
              <li><Link to="/cookies" className="hover:text-amber-300" data-testid="footer-link-cookies">Zásady cookies</Link></li>
              <li>
                <button
                  type="button"
                  onClick={() => cookieCtx && cookieCtx.openSettings()}
                  data-testid="footer-cookie-settings"
                  className="hover:text-amber-300 text-left"
                >
                  Nastavení cookies
                </button>
              </li>
              <li><Link to="/obchodni-podminky" className="hover:text-amber-300" data-testid="footer-link-terms">Obchodní podmínky</Link></li>
              <li><Link to="/pravni-pouceni" className="hover:text-amber-300" data-testid="footer-link-legal">Právní poučení</Link></li>
            </ul>
            <div className="mt-6 text-xs uppercase tracking-[0.2em] text-amber-300/80">Partner pro STK a emise</div>
            <div className="mt-2 inline-flex items-center gap-3 rounded-2xl border border-amber-300/20 bg-amber-300/5 px-4 py-2">
              <span className="font-heading text-base font-bold text-amber-200 tracking-wide">PSOTA</span>
              <span className="text-[10px] uppercase tracking-[0.2em] text-amber-300/70">Znojmo</span>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 grid sm:grid-cols-2 gap-4 text-xs text-slate-500">
          <div>
            © {new Date().getFullYear()} STK Komfort Znojmo™. Zastřešeno společností{" "}
            <span className="text-slate-400">UNOEXTREME Capital Group s.r.o.</span>, IČO 09361430.
          </div>
          <div className="sm:text-right">
            Koncept, strategie, webové zpracování a SEO:{" "}
            <span className="text-amber-300/90">Charlie Xavier De Acapulco</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
